import { ACTIVITY_KEY, LAST_API_KEY, REDIRECT_KEY } from './sessionKeys'

/** Suppress other-tab session dialog during intentional logout / 401 redirect. */
let suppressOtherTabDialog = false

export function beginIntentionalSessionEnd(): void {
  suppressOtherTabDialog = true
}

export function isIntentionalSessionEnd(): boolean {
  return suppressOtherTabDialog
}

export function setActivityTime(timestamp: number = Date.now()): void {
  try {
    localStorage.setItem(ACTIVITY_KEY, String(timestamp))
  } catch {
    /* ignore */
  }
}

export function getActivityTime(): number {
  try {
    const raw = localStorage.getItem(ACTIVITY_KEY)
    if (!raw) return 0
    const parsed = Number(raw)
    return Number.isFinite(parsed) ? parsed : 0
  } catch {
    return 0
  }
}

export function setLastApiRequestTime(timestamp: number = Date.now()): void {
  try {
    localStorage.setItem(LAST_API_KEY, String(timestamp))
  } catch {
    /* ignore */
  }
}

export function getLastApiRequestTime(): number {
  try {
    const raw = localStorage.getItem(LAST_API_KEY)
    if (!raw) return 0
    const parsed = Number(raw)
    return Number.isFinite(parsed) ? parsed : 0
  } catch {
    return 0
  }
}

export function setPostLoginRedirect(path: string): void {
  if (!path || path === '/login' || path.startsWith('/auth/')) return
  try {
    localStorage.setItem(REDIRECT_KEY, path)
  } catch {
    /* ignore */
  }
}

/** Consume post-login redirect once; only same-origin relative paths. */
export function consumePostLoginRedirect(): string | null {
  try {
    const redirectTo = localStorage.getItem(REDIRECT_KEY)
    if (!redirectTo) return null
    localStorage.removeItem(REDIRECT_KEY)
    if (!isSafeInternalRedirect(redirectTo)) return null
    return redirectTo
  } catch {
    return null
  }
}

export function isSafeInternalRedirect(path: string): boolean {
  if (!path.startsWith('/') || path.startsWith('//')) return false
  if (path.includes('://')) return false
  if (path.startsWith('/login') || path.startsWith('/auth/')) return false
  return true
}
